import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subject} from "rxjs";
import {ActivityI, RedirectI, TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";

@Component({
  selector: 'app-redirector',
  templateUrl: './redirector.component.html',
  styleUrls: ['./redirector.component.scss']
})
export class RedirectorComponent implements OnChanges {

  taskStatus = TaskStatus

  @Input() activityData: ActivityI | null = null;
  @Input() taskData: TaskI | null = null;

  url!: string;
  config!: RedirectI;
  currentTaskStatus!: string;

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Redirector Changes =>", changes);

    if (changes["taskData"]){
      this.taskData = changes["taskData"]["currentValue"]
      this.currentTaskStatus = this.taskData?.status?.key || '';
    }

    if (changes["activityData"]){

      this.activityData = changes["activityData"]["currentValue"]

      const data =this.activityData?.metadata || {};

      this.config = (this.activityData?.redirect || {})?.[this.currentTaskStatus] || (this.activityData?.redirect || {})?.['default']

      console.log("Redirect config => ", this.config);

      this.url = eval("`"+String(this.config.url ?? "")+"`");
      console.log('redirect url => ',this.url);
    }
  }
}
